import { Link } from 'react-router-dom'
import { RecentClient } from '@/lib/api/dashboard/dashboard-api'
import { MdPeople, MdArrowForward, MdEmail, MdPhone } from 'react-icons/md'
import { format, parseISO } from 'date-fns'

interface RecentClientsTableProps {
    clients: RecentClient[]
}

export default function RecentClientsTable({ clients }: RecentClientsTableProps) {
    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 overflow-hidden">
            <div className="bg-gradient-to-r from-secondary/10 to-accent/10 px-5 py-4 border-b border-base-300/50">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="p-2 rounded-lg bg-secondary/20">
                            <MdPeople className="text-secondary text-lg" />
                        </div>
                        <h3 className="text-lg font-semibold text-base-content">
                            Clientes Recentes
                        </h3>
                    </div>
                    <Link
                        to="/person/clients"
                        className="btn btn-ghost btn-sm gap-1"
                    >
                        Ver todos
                        <MdArrowForward />
                    </Link>
                </div>
            </div>

            <div className="overflow-x-auto">
                {clients.length === 0 ? (
                    <div className="text-center py-8 text-base-content/50">
                        Nenhum cliente recente
                    </div>
                ) : (
                    <table className="table table-sm">
                        <thead>
                            <tr className="text-xs text-base-content/60">
                                <th>Nome</th>
                                <th>Contato</th>
                                <th>Cadastro</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clients.slice(0, 5).map(client => (
                                <tr key={client.id} className="hover">
                                    <td>
                                        <Link
                                            to={`/person/clients/${client.id}`}
                                            className="font-medium text-base-content hover:text-secondary"
                                        >
                                            {client.name}
                                        </Link>
                                    </td>
                                    <td>
                                        <div className="flex flex-col gap-1">
                                            {client.email && (
                                                <span className="flex items-center gap-1 text-xs text-base-content/60">
                                                    <MdEmail className="text-sm" />
                                                    {client.email}
                                                </span>
                                            )}
                                            {client.phone && (
                                                <span className="flex items-center gap-1 text-xs text-base-content/60">
                                                    <MdPhone className="text-sm" />
                                                    {client.phone}
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="text-base-content/60 text-xs">
                                        {format(parseISO(client.createdAt), 'dd/MM/yyyy')}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}
